import React, {Component, Suspense} from 'react';
import {Switch, Redirect, Route} from 'react-router-dom';
import Loadable from 'react-loadable';
import '../../node_modules/font-awesome/scss/font-awesome.scss';
import moment from "moment";
import axios from 'axios';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";
import crypt from "node-cryptex";

const k = new Buffer(32);
const v = new Buffer(16);

const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});

const Login = Loadable({
    loader: () => import('../FCS/Login'),
    loading: Loader
});

function isSessionValid() {
    const raw = localStorage.getItem('_rki');
    const user = localStorage.getItem('_jki') || '';
    if (!raw || !user) return false;
    try {
        const hourExpire = crypt.decrypt(raw, k, v);
        return hourExpire >= moment().format();
    } catch {
        return false;
    }
}

class App extends Component {

    state = {
        loggedIn: isSessionValid()
    };

    componentDidMount() {
        this._interceptor = axios.interceptors.response.use(
            res => res,
            err => {
                const errName = err.response && err.response.data && err.response.data.message && err.response.data.message.name;
                if (errName === 'TokenExpiredError') {
                    localStorage.clear();
                    window.location.href = '/login';
                }
                return Promise.reject(err);
            }
        );
        this._timer = setInterval(() => {
            const valid = isSessionValid();
            if (this.state.loggedIn !== valid) {
                this.setState({loggedIn: valid});
            }
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this._timer);
        axios.interceptors.response.eject(this._interceptor);
    }

    render() {
        const {loggedIn} = this.state;

        const menu = routes.map((route, index) => {
            return (route.component) ? (
                <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => (
                        <route.component {...props} />
                    )}/>
            ) : (null);
        });

        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader/>}>
                        <Switch>
                            {
                                loggedIn
                                    ?
                                    <>
                                        {menu}
                                        <Route path="/" component={AdminLayout}/>
                                    </>
                                    :
                                    <>
                                        <Route path="/login" exact component={Login}/>
                                        <Redirect to="/login"/>
                                    </>
                            }
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;
